export const SUBMIT_GENERATE_APID_PENDING = 'SUBMIT_GENERATE_APID_PENDING'
export const SUBMIT_GENERATE_APID_FULFILLED = 'SUBMIT_GENERATE_APID_FULFILLED'
export const SUBMIT_GENERATE_APID_REJECTED = 'SUBMIT_GENERATE_APID_REJECTED'

export const FETCH_GENERATED_APIDS_PENDING = 'FETCH_GENERATED_APIDS_PENDING'
export const FETCH_GENERATED_APIDS_FULFILLED = 'FETCH_GENERATED_APIDS_FULFILLED'
export const FETCH_GENERATED_APIDS_REJECTED = 'FETCH_GENERATED_APIDS_REJECTED'

export const GENERATE_APID_FORM_NAME = 'generateAPIDForm'
export const GENERATE_APID_EDUCATION_PERIOD_CD_FIELD = 'educationPeriodCd'
export const GENERATE_APID_ETS_EXAM_CD_FIELD = 'etsExamCd'
export const GENERATE_APID_AICODE_FIELD = 'testingAiCode'
export const GENERATE_APID_TEST_WINDOW_FIELD = 'testWindow'
export const GENERATE_APID_SERIAL_NUM_FIELD = 'batchNumber'
export const GENERATE_APID_ADDRESS_TYPE_FIELD = 'mailingAddress.addressType'
export const GENERATE_APID_ADDRESS1_FIELD = 'mailingAddress.street1'
export const GENERATE_APID_ADDRESS2_FIELD = 'mailingAddress.street2'
export const GENERATE_APID_ADDRESS3_FIELD = 'mailingAddress.street3'
export const GENERATE_APID_CITY_FIELD = 'mailingAddress.city'
export const GENERATE_APID_STATE_FIELD = 'mailingAddress.stateCode'
export const GENERATE_APID_PROVINCE_FIELD = 'mailingAddress.province'
export const GENERATE_APID_ZIP5_FIELD = 'mailingAddress.zip5'
export const GENERATE_APID_ZIP4_FIELD = 'mailingAddress.zip4'
export const GENERATE_APID_POSTAL_CODE_FIELD = 'mailingAddress.internationalPostalCode'
export const GENERATE_APID_COUNTRY_FIELD = 'mailingAddress.countryCode'
export const GENERATE_APID_REGEION_CODE_FIELD = 'mailingAddress.regionCode'
export const GENERATE_APID_FIRST_NAME_FIELD = 'firstName'
export const GENERATE_APID_LAST_NAME_FIELD = 'lastName'
export const GENERATE_APID_DOB_FIELD = 'birthDate'
export const ADDRESS_DOMESTIC = 'DOMESTIC'
export const ADDRESS_INTERNATIONAL = 'INTERNATIONAL'

export const GENERATE_APID_FORM_FIELDS = {
  edpdCd: GENERATE_APID_EDUCATION_PERIOD_CD_FIELD,
  examCd: GENERATE_APID_ETS_EXAM_CD_FIELD,
  aiCode: GENERATE_APID_AICODE_FIELD,
  testWindow: GENERATE_APID_TEST_WINDOW_FIELD,
  serialNum: GENERATE_APID_SERIAL_NUM_FIELD,
  addrType: GENERATE_APID_ADDRESS_TYPE_FIELD,
  addr1: GENERATE_APID_ADDRESS1_FIELD,
  addr2: GENERATE_APID_ADDRESS2_FIELD,
  addr3: GENERATE_APID_ADDRESS3_FIELD,
  city: GENERATE_APID_CITY_FIELD,
  state: GENERATE_APID_STATE_FIELD,
  province: GENERATE_APID_PROVINCE_FIELD,
  zip5: GENERATE_APID_ZIP5_FIELD,
  zip4: GENERATE_APID_ZIP4_FIELD,
  postalCd: GENERATE_APID_POSTAL_CODE_FIELD,
  country: GENERATE_APID_COUNTRY_FIELD,
  region: GENERATE_APID_REGEION_CODE_FIELD,
  firstName: GENERATE_APID_FIRST_NAME_FIELD,
  lastName: GENERATE_APID_LAST_NAME_FIELD,
  dob: GENERATE_APID_DOB_FIELD,
}

// export const GENERATE_APID_FORM_FIELDS = {
//   [GENERATE_APID_AICODE_FIELD]: { label: 'Testing AI', placeholder: 'Enter valid Testing AI', longName: GENERATE_APID_AICODE_FIELD, required: true },
//   [GENERATE_APID_SERIAL_NUM_FIELD]: { label: 'Batch/Serial number', placeholder: 'Enter Batch/Serial number', longName: GENERATE_APID_SERIAL_NUM_FIELD, required: true },
//   [GENERATE_APID_ETS_EXAM_CD_FIELD]: { label: 'ETS Exam Code', placeholder: 'Enter ETS Exam Code', longName: GENERATE_APID_ETS_EXAM_CD_FIELD, required: true },
//   [GENERATE_APID_TEST_WINDOW_FIELD]: { label: 'Exam Administration', placeholder: 'Enter exam administration', longName: GENERATE_APID_TEST_WINDOW_FIELD, required: true },
//   [GENERATE_APID_FIRST_NAME_FIELD]: { label: 'Student first name', placeholder: 'Enter student first name', longName: GENERATE_APID_FIRST_NAME_FIELD, required: false },
//   [GENERATE_APID_LAST_NAME_FIELD]: { label: 'Student last name', placeholder: 'Enter student last name', longName: GENERATE_APID_LAST_NAME_FIELD, required: false },
//   [GENERATE_APID_DOB_FIELD]: { label: 'DOB (YYYY-MM-DD)', placeholder: 'Enter DOB', longName: GENERATE_APID_DOB_FIELD, required: false },
//   [GENERATE_APID_ADDRESS_TYPE_FIELD]: { longName: `mailingAddress.${GENERATE_APID_ADDRESS_TYPE_FIELD}`, required: false },
//   [GENERATE_APID_ADDRESS1_FIELD]: { label: 'Address 1', longName: `mailingAddress.${GENERATE_APID_ADDRESS1_FIELD}`, required: true },
//   [GENERATE_APID_ADDRESS2_FIELD]: { label: 'Address 2', longName: `mailingAddress.${GENERATE_APID_ADDRESS2_FIELD}`, required: false },
//   [GENERATE_APID_ADDRESS3_FIELD]: { label: 'Address 3', longName: `mailingAddress.${GENERATE_APID_ADDRESS3_FIELD}`, required: false },
//   [GENERATE_APID_STATE_FIELD]: { label: 'State', longName: `mailingAddress.${GENERATE_APID_STATE_FIELD}`, required: true },
//   [GENERATE_APID_ZIP5_FIELD]: { label: 'Zip', placeholder: 'Enter 5 or 9 digit code', longName: `mailingAddress.${GENERATE_APID_ZIP5_FIELD}`, required: true },
//   [GENERATE_APID_PROVINCE_FIELD]: { label: 'Province', longName: `mailingAddress.${GENERATE_APID_PROVINCE_FIELD}`, required: true },
//   [GENERATE_APID_POSTAL_CODE_FIELD]: { label: 'Postal Code', longName: `mailingAddress.${GENERATE_APID_POSTAL_CODE_FIELD}`, required: true },
//   [GENERATE_APID_COUNTRY_FIELD]: { label: 'Country', longName: `mailingAddress.${GENERATE_APID_COUNTRY_FIELD}`, required: true },
// }
